import React from 'react';

import './index.scss';

const BubbleVM = ({ message }) => {
  return (
    <div className="vm">
      <div className="vm__bubble">
       <a href={message} target="_blank">Play the voicemail</a>
      </div>
    </div>
  );
};

export default BubbleVM;